"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = void 0;
const Box_1 = require("./Box");
exports.Image = Box_1.Box.withComponent('img');

//# sourceMappingURL=Image.js.map
